<template>
  <div class="top-bar color-scheme-transparent">
    <div class="top-menu-controls">
      <div class="logged-user-w" v-if="this.$root.isAuthenticated">
        <div class="logged-user-i">
          <div class="avatar-w">
            <img alt="" :src="this.$root.userProfile.avatar">
          </div>
          <div class="logged-user-menu color-style-bright">
            <div class="logged-user-avatar-info">
              <div class="avatar-w">
                <img alt="" :src="this.$root.userProfile.avatar">
              </div>
              <div class="logged-user-info-w">
                <div class="logged-user-name">
                  {{ this.$root.userProfile.username }}
                </div>
                <div class="logged-user-role">
                  {{ this.$root.userProfile.rank.name }}
                </div>
              </div>
            </div>
            <div class="bg-icon">
              <i class="os-icon os-icon-fingerprint"></i>
            </div>
            <ul>
              <li>
                <a href="#" @click="$root.logout()"><i class="os-icon os-icon-signs-11"></i><span>Logout</span></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="logged-user-w" v-else>
        <div class="logged-user-i">
          <div class="avatar-w">
            <i class="fa fa-user-circle fa-2x"></i>
          </div>
          <div class="logged-user-menu color-style-bright">
            <div class="logged-user-avatar-info">
              <div class="avatar-w">
                <img alt="" src="https://avatar.tobi.sh/">
              </div>
              <div class="logged-user-info-w">
                <div class="logged-user-name">
                  Login with your
                </div>
                <div class="logged-user-role">
                  Steam Account
                </div>
              </div>
            </div>
            <div class="bg-icon">
              <i class="os-icon os-icon-fingerprint"></i>
            </div>
            <ul>
              <li>
                <a class="nav-link" href="https://api.onetap.gg/api/v3/auth/steam">
                  <i class="fa fa-sign-in-alt"></i>
                  <span>Login with Steam</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Navbar',
  data () {
    return {
      //
    }
  },
  methods: {
    getTimeString(timeInMs) {
      var delim = ":";
      var hours = Math.ceil(timeInMs / (1000 * 60 * 60) % 60);
      var minutes = Math.floor(timeInMs / (1000 * 60) % 60);
      var seconds = Math.floor(timeInMs / 1000 % 60);

      hours = hours < 10 ? '0' + hours : hours;
      minutes = minutes < 10 ? '0' + minutes : minutes;
      seconds = seconds < 10 ? '0' + seconds : seconds;
      return hours + delim + minutes + delim + seconds;
    },
    getHuman(timestamp) {
      return window.moment(timestamp).fromNow();
    },
    exitQueue() {
      this.axios.post(`${this.API_URL}/kraken/lobbies/${this.$root.krakenLobby.id}/unqueue`).then((res) => {
        //
      });
    },
    goToMatch() {
      this.$router.push(`/kraken/match/${this.$root.krakenMatch.id}`);
    }
  },
  created() {
    //
  }
}
</script>
